import { getTranslationOrInnerText, isHTMLElement } from 'whisper-base';
import { NudgeTypes } from '../../constants';
export const Definition = {
  // data-onboarding-name as popover is from the shared component and used within
  // several different tour scenarios. We only want to track ones also with
  // our nudge type attribute
  selector: '[data-onboarding-name="popover"][data-nudge-type="ONBOARDING_DEMO"]',
  shouldTrackRenderedForChild: () => {
    return true;
  },
  shouldTrackDismissedForChild: () => {
    return true;
  },
  getNudgeProperties: ({
    element
  }) => {
    const header = element.querySelector('header');
    const title = isHTMLElement(header) ? getTranslationOrInnerText(header) : 'no-title';
    const nextElementSibling = header === null || header === void 0 ? void 0 : header.nextElementSibling;
    const text = isHTMLElement(nextElementSibling) ? getTranslationOrInnerText(nextElementSibling) : 'no-text';
    return {
      type: NudgeTypes.ONBOARDING_DEMO,
      title,
      text
    };
  }
};